import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("camper_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("camper_token"))
      .finally(() => setLoading(false));
  }, []);

  // Con segundo factor, la contraseña sola no da sesión: devuelve {mfa_required, mfa_token} para el segundo paso.
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return { mfa_required: true, mfa_token: data.mfa_token };
    localStorage.setItem("camper_token", data.token);
    setUser(data.user);
    return data.user;
  };

  // Segundo paso: el código de la app (o uno de recuperación).
  const loginTotp = async (mfaToken, code) => {
    const { data } = await api.post("/auth/login/totp", { mfa_token: mfaToken, code: code.replace(/\s/g, "") });
    localStorage.setItem("camper_token", data.token);
    setUser(data.user);
    return data.user;
  };

  // Tras activar o desactivar el segundo factor, /auth/me cambia (totp_enabled, totp_setup_required).
  const refresh = async () => setUser((await api.get("/auth/me")).data);

  // Tras cambiar la contraseña el servidor da una sesión nueva (las viejas caducan).
  const replaceToken = (token) => localStorage.setItem("camper_token", token);

  const logout = () => {
    localStorage.removeItem("camper_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginTotp, logout, replaceToken, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
